export default __webpack_public_path__ + "static/media/17_spinner.6d6e1eda.svg";